export default __webpack_public_path__ + "static/media/Refund-Policy.2510d92e.jpg";